import { render, staticRenderFns } from "./DiscountModal.vue?vue&type=template&id=542b4ea6&scoped=true"
import script from "./DiscountModal.vue?vue&type=script&lang=js"
export * from "./DiscountModal.vue?vue&type=script&lang=js"
import style0 from "./DiscountModal.vue?vue&type=style&index=0&id=542b4ea6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542b4ea6",
  null
  
)

export default component.exports